import { render, staticRenderFns } from "./GenerateReports.vue?vue&type=template&id=ba0cbba2"
import script from "./GenerateReports.vue?vue&type=script&lang=js"
export * from "./GenerateReports.vue?vue&type=script&lang=js"
import style0 from "./GenerateReports.vue?vue&type=style&index=0&id=ba0cbba2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports